import { useTranslation } from "react-i18next"

interface Props {
  onGetPlan: () => void
  timeLeft: string
}

export default function PaywallTimerBar({ onGetPlan, timeLeft }: Props) {
  const { t } = useTranslation()

  return (
    <div className="sticky top-0 z-30 animate-fade-in border-b border-vm-line bg-vm-cream/95 backdrop-blur">
      <div className="vm-container flex items-center justify-between gap-3 py-3">
        <div>
          <p className="text-xs font-medium text-vm-muted">
            {t("pages.checkout.paywall.timer.discountReserved")}
          </p>
          <p className="text-2xl font-bold tabular-nums text-vm-red">
            {timeLeft}
          </p>
        </div>

        <button
          className="animate-pulse-cta rounded-vm-md bg-vm-primary-solid px-5 py-3 text-sm font-semibold text-white shadow-cta transition-opacity hover:opacity-90"
          onClick={onGetPlan}
          type="button"
        >
          {t("pages.checkout.paywall.getMyPlan")}
        </button>
      </div>
    </div>
  )
}
